/**
 * Respaldo y recuperación del carrito (botón "back" del navegador)
 *
 * Al tramitar un pedido en /pages/datos-de-envio se crea un Draft Order y se
 * vacía el carro de Shopify con /cart/clear.js antes de redirigir a la invoice.
 * Si el cliente presiona "back" desde la invoice, vuelve al sitio con el carro
 * ya vacío y pierde sus productos y datos.
 *
 * Para evitarlo, justo antes de vaciar el carro guardamos un respaldo en
 * localStorage (window.catadoresBackupCart). Si el cliente regresa con "back",
 * se restauran AUTOMÁTICAMENTE el carrito y los datos del formulario (sin
 * preguntar). El respaldo expira a los 30 min como salvaguarda.
 *
 * Se carga globalmente desde theme.liquid.
 */
(function () {
  var BACKUP_KEY = 'catadores_cart_backup';
  var BACKUP_TTL_MS = 30 * 60 * 1000; // 30 minutos

  // Guarda un respaldo del carro antes de vaciarlo.
  // Llamar justo antes de /cart/clear.js, pasando el cart de /cart.js.
  // checkoutData (opcional): datos del formulario de envío para recuperarlos también.
  window.catadoresBackupCart = function (cart, discountCode, checkoutData) {
    try {
      if (!cart || !cart.items || cart.items.length === 0) return;
      var backup = {
        items: cart.items.map(function (item) {
          return {
            id: item.variant_id || item.id,
            quantity: item.quantity,
            properties: item.properties || {}
          };
        }),
        discount: discountCode || null,
        checkout: checkoutData || null,
        ts: Date.now()
      };
      localStorage.setItem(BACKUP_KEY, JSON.stringify(backup));
    } catch (e) {
      console.warn('No se pudo respaldar el carrito:', e);
    }
  };

  function readBackup() {
    try {
      var raw = localStorage.getItem(BACKUP_KEY);
      if (!raw) return null;
      var backup = JSON.parse(raw);
      if (!backup || !backup.items || !backup.items.length) return null;
      // Descartar respaldos vencidos
      if (!backup.ts || (Date.now() - backup.ts) > BACKUP_TTL_MS) {
        localStorage.removeItem(BACKUP_KEY);
        return null;
      }
      return backup;
    } catch (e) {
      return null;
    }
  }

  function clearBackup() {
    try { localStorage.removeItem(BACKUP_KEY); } catch (e) {}
  }

  // Overlay de carga para tapar el parpadeo mientras se restaura y recarga
  function showLoadingOverlay(message) {
    if (!document.getElementById('catadores-cr-spin-style')) {
      var st = document.createElement('style');
      st.id = 'catadores-cr-spin-style';
      st.textContent = '@keyframes catadoresCrSpin{to{transform:rotate(360deg)}}';
      document.head.appendChild(st);
    }

    var overlay = document.createElement('div');
    overlay.id = 'catadores-cart-restore-loading';
    overlay.style.cssText = [
      'position:fixed', 'inset:0', 'z-index:99999',
      'background:rgba(255,255,255,0.92)',
      'display:flex', 'flex-direction:column', 'align-items:center', 'justify-content:center',
      'gap:16px'
    ].join(';');

    var spinner = document.createElement('div');
    spinner.style.cssText = [
      'width:38px', 'height:38px', 'border-radius:50%',
      'border:3px solid #e0d5e2', 'border-top-color:#311533',
      'animation:catadoresCrSpin 0.8s linear infinite'
    ].join(';');

    var text = document.createElement('div');
    text.textContent = message || 'Recuperando tu carrito...';
    text.style.cssText = 'font-size:15px;color:#311533;font-weight:600;';

    overlay.appendChild(spinner);
    overlay.appendChild(text);
    document.body.appendChild(overlay);
    return overlay;
  }

  // Re-agrega los productos respaldados al carro, restaura datos y recarga
  function restoreCart(backup) {
    var loader = showLoadingOverlay('Recuperando tu carrito...');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: backup.items.map(function (i) {
          return { id: i.id, quantity: i.quantity, properties: i.properties || {} };
        })
      })
    })
      .then(function (resp) {
        if (!resp.ok) throw new Error('cart/add status ' + resp.status);
        // Restaurar el cupón aplicado, si lo había. Se reescribe el timestamp para
        // reiniciar el TTL de 10 min (ver getFreshDiscountCode en page.pre-checkout.liquid).
        if (backup.discount) {
          try {
            localStorage.setItem('catadores_discount_code', backup.discount);
            localStorage.setItem('catadores_discount_code_ts', String(Date.now()));
          } catch (e) {}
        }
        // Restaurar los datos del formulario de envío. La página /datos-de-envio
        // los rellena al cargar leyendo 'catadores_checkout_data' (ver page.pre-checkout.liquid).
        if (backup.checkout) {
          try { localStorage.setItem('catadores_checkout_data', JSON.stringify(backup.checkout)); } catch (e) {}
        }
        clearBackup();
        // Recargar para que el cart drawer / sidebar / formulario reflejen lo recuperado
        window.location.reload();
      })
      .catch(function (err) {
        console.error('No se pudo recuperar el carrito:', err);
        clearBackup();
        if (loader) loader.remove();
        // Estado seguro: llevar al carro real (vacío) para no dejar basura del bfcache
        window.location.href = '/cart';
      });
  }

  // Detecta el regreso vía "back" (bfcache o navegación back/forward) y restaura solo
  function maybeAutoRestore(event) {
    var backup = readBackup();
    if (!backup) return;

    var cameFromBack = false;
    if (event && event.persisted) {
      cameFromBack = true; // restaurado desde bfcache (típico del botón back)
    } else {
      try {
        var nav = performance.getEntriesByType('navigation')[0];
        if (nav && nav.type === 'back_forward') cameFromBack = true;
      } catch (e) {}
    }
    if (!cameFromBack) return;

    restoreCart(backup);
  }

  window.addEventListener('pageshow', maybeAutoRestore);
})();
